import { FormLabel, Typography, TypographyProps } from '@mui/material';
import { styled, Theme } from '@mui/material/styles';
import { CardElement, CardElementProps } from '@stripe/react-stripe-js';
import { InputHTMLAttributes } from 'react';

export const PaymentWrapperPaypal = styled('div')(({ theme }) => ({
    maxWidth: '435px',
    margin: '0 auto 35px'
}));

export const PaymentWrapper = styled('div')(() => ({
    margin: '0 auto 35px'
}));

export const PaymentButtonBox = styled('div')(() => ({
    marginBottom: '15px'
}));

export const PaymentInfo = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    margin: '0 0 30px'
}));

export const PaymentInfoTitle = styled(Typography)<TypographyProps>(({ theme }) => ({
    margin: '0 7px 0 0',
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(18)
}));

export const PaymentInfoAmountBox = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center'
}));

export const PaymentInfoAmount = styled('div')(({ theme }) => ({
    margin: '0 0 0 5px',
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(18)
}));

export const PaymentGroup = styled('div')(() => ({
    margin: '0 0 10px'
}));

export const PaymentForm = styled('form')(({ theme }) => ({
    margin: '0 0 10px',
    padding: '20px',
    borderRadius: '4px',
    border: `1px solid ${theme.palette.divider}`,
    '& .MuiFormControlLabel-root': {
        margin: '0 0 10px'
    },
    '& .MuiFormControlLabel-label': {
        fontSize: theme.typography.pxToRem(16),
        color: theme.palette.text.secondary
    },
    '& .error-message': {
        color: '#ef4439',
        fontSize: theme.typography.pxToRem(12)
    }
}));

export const PaymentLabel = styled(FormLabel)(({ theme }) => ({
    display: 'block',
    margin: '0 0 10px',
    fontWeight: 500,
    lineHeight: '1.3',
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.text.primary
}));
type PaymentControlProps = InputHTMLAttributes<HTMLInputElement> | CardElementProps;

export const getPaymentControlStyles = (theme: Theme) =>  ({
    width: '100%',
    margin: '0 0 5px',
    padding: '16px',
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 400,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    borderRadius: '4px',
    color: theme.palette.text.primary,
    lineHeight: '1.3',
    transition: '0.15s ease-in-out',
    '&::placeholder': {
        color: theme.palette.text.disabled
    },
    '&:focus': {
        outline: 'none'
    },
    '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.01)'
    }
})

export const PaymentControl = styled('input')<PaymentControlProps>(({theme}) =>  getPaymentControlStyles(theme));
export const PaymentCardElementControl = styled(CardElement)<PaymentControlProps>(({theme}) => getPaymentControlStyles(theme));

export const Signature = styled('div')(() => ({
    display: 'inline-block',
    maxWidth: '380px'
}));